module.exports = __webpack_public_path__ + "front/img/c10.b99ae61a.png";